import { getAdminAxiosInstance } from "../../../api/Admin";

export const addOrUpdateCustomOffers = async (body) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/offer/create`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteCustomOffer = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`offer/delete?offer_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getDataById = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`offer/details?offer_id=${id}`);
    return response;
  } catch (error) {
    return error.response.data;
  }
};
